import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const fr = {
  common: {
    app_name: "NEXORA·CAB",
    loading: "Chargement…",
    cancel: "Annuler",
    confirm: "Confirmer",
    save: "Sauvegarder",
    back: "Retour",
    close: "Fermer",
    yes: "Oui",
    no: "Non",
    language: "Langue",
    language_fr: "Français",
    language_en: "Anglais",
    language_ln: "Lingala",
    language_sw: "Swahili",
  },
  auth: {
    login: "Connexion",
    register: "Créer un compte",
    logout: "Se déconnecter",
    email_or_phone: "Email ou téléphone",
    password: "Mot de passe",
    full_name: "Nom complet",
    phone: "Téléphone",
    email: "Email",
    city: "Ville",
    referral_code: "Code parrain (optionnel)",
    welcome: "Bienvenue sur NEXORA-CAB",
    role_customer: "Client",
    role_driver: "Chauffeur",
    no_account: "Pas encore inscrit ?",
    have_account: "Déjà inscrit ?",
    create_account: "Créer mon compte",
    sign_in: "Se connecter",
  },
  home: {
    hello: "Bonjour",
    where_to: "Où allez-vous ?",
    tap_map: "Tapez sur la carte · prix instantané",
    active_ride: "Course en cours",
    last_rides: "Dernières courses",
    see_all: "Tout voir",
    none_yet: "Aucune course — commandez la première !",
    loyalty: "Fidélité",
    points: "Points",
    next_tier_progress: "vers",
    geo_in: "Vous êtes à",
    geo_account_in: "Votre compte est enregistré à",
    geo_restricted: "Les courses sont limitées à votre ville d'origine.",
  },
  ride: {
    step_pickup: "Où êtes-vous ?",
    step_dest: "Où allez-vous ?",
    step_review: "Choisir le véhicule",
    search_pickup: "Chercher mon adresse de départ...",
    search_dest: "Chercher ma destination...",
    choose_vehicle: "Choisir le véhicule",
    payment: "Paiement",
    subtotal: "Sous-total",
    promo_code: "Code promo",
    promo_apply: "Appliquer",
    total: "Total",
    order: "Commander",
    searching_driver: "Recherche d'un chauffeur",
    en_route: "Chauffeur en route",
    arrived: "Chauffeur arrivé",
    in_progress: "Course en cours",
    completed: "Course terminée",
    cancelled: "Course annulée",
    pin_hint: "Code à donner au chauffeur",
    pay_now: "Payer maintenant",
    cancel: "Annuler",
    tip: "Pourboire",
    rate: "Noter",
    back_home: "Retour accueil",
    city_lock: "Zone",
    city_lock_max: "30 km max",
    out_of_zone: "Ce point est hors zone de service",
  },
  wallet: {
    title: "Paiements",
    balance: "Historique",
    topup: "Indisponible",
    send_money: "Historique de paiement",
    send_subtitle: "Au chauffeur ou à n'importe qui",
    recipient_phone: "Téléphone destinataire",
    amount: "Montant",
    note: "Note (optionnel)",
    send: "Voir",
    transactions: "Paiements",
    no_transactions: "Aucun paiement",
    transfer_success: "Transfert effectué",
  },
  driver: {
    online: "EN LIGNE",
    offline: "HORS LIGNE",
    go_online: "Passez en ligne pour recevoir des courses",
    no_requests: "Aucune demande pour le moment",
    incoming: "Demandes entrantes",
    active_ride: "Course active",
    arrived_btn: "Je suis arrivé",
    start_btn: "Démarrer",
    complete_btn: "Terminer",
    pending_banner: "Compte en attente de validation admin",
    earnings: "Revenus totaux",
    earnings_note: "Après commission 20% NEXORA",
    total_rides: "Courses",
    documents_title: "Mes documents",
    documents_subtitle: "Téléversez permis, carte grise, pièce d'identité et assurance",
    upload: "Téléverser",
    doc_driver_license: "Permis de conduire",
    doc_vehicle_registration: "Carte grise",
    doc_id_card: "Pièce d'identité",
    doc_insurance: "Assurance",
    doc_pending: "En attente de validation",
    doc_approved: "Approuvé",
    doc_rejected: "Rejeté",
    doc_upload_success: "Document téléversé",
  },
  rating: {
    title: "Noter",
    submit: "Envoyer l'évaluation",
    comment_placeholder: "Commentaire (optionnel)…",
    thanks: "Merci !",
  },
  sos: {
    trigger: "SOS",
    title: "Déclencher SOS",
    description: "Nous enverrons votre position GPS et les détails de la course à l'équipe NEXORA.",
    note_placeholder: "Décrivez la situation (optionnel)…",
    confirm: "Déclencher l'alerte",
    sent: "Alerte envoyée",
    call_112: "Appeler le 112",
  },
};

const ln = {
  common: {
    app_name: "NEXORA·CAB",
    loading: "Kozela…",
    cancel: "Tika",
    confirm: "Ndima",
    save: "Bomba",
    back: "Zonga",
    close: "Kanga",
    yes: "Ee",
    no: "Te",
    language: "Lokota",
    language_fr: "Falansé",
    language_en: "Anglais",
    language_ln: "Lingala",
    language_sw: "Swahili",
  },
  auth: {
    login: "Kokota",
    register: "Sala konti",
    logout: "Kobima",
    email_or_phone: "Imeli to Telefone",
    password: "Mot de passe",
    full_name: "Kombo mobimba",
    phone: "Telefone",
    email: "Imeli",
    city: "Mboka",
    referral_code: "Kode ya mobateli (soki ozali na yango)",
    welcome: "Mboté na NEXORA-CAB",
    role_customer: "Moto ya Lisalisi",
    role_driver: "Motámboli",
    no_account: "Ozali na konti te ?",
    have_account: "Ozali na konti ?",
    create_account: "Sala konti na ngai",
    sign_in: "Kokota",
  },
  home: {
    hello: "Mbote",
    where_to: "Okei wapi ?",
    tap_map: "Finga na karta · talo mbala moko",
    active_ride: "Mobembo ya sikoyo",
    last_rides: "Mibembo ya suka",
    see_all: "Tala nionso",
    none_yet: "Mobembo te — sala oyo ya liboso !",
    loyalty: "Bosembo",
    points: "Biloko",
    next_tier_progress: "mpo na",
    geo_in: "Ozali na",
    geo_account_in: "Konti na yo ezali na",
    geo_restricted: "Mibembo ezali se na mboka na yo.",
  },
  ride: {
    step_pickup: "Ozali wapi ?",
    step_dest: "Okei wapi ?",
    step_review: "Pona moto",
    search_pickup: "Luka esika ya kobanda...",
    search_dest: "Luka esika ya kokoma...",
    choose_vehicle: "Pona moto",
    payment: "Kofuta",
    subtotal: "Talo ya yambo",
    promo_code: "Kode ya promo",
    promo_apply: "Salela",
    total: "Nionso",
    order: "Tinda",
    searching_driver: "Koluka motámboli",
    en_route: "Motámboli azali koya",
    arrived: "Motámboli akomi",
    in_progress: "Mobembo ezali kokende",
    completed: "Mobembo esili",
    cancelled: "Mobembo eboyami",
    pin_hint: "Kode ya kopesa motámboli",
    pay_now: "Futa sikoyo",
    cancel: "Tika",
    tip: "Matondo",
    rate: "Pesa point",
    back_home: "Zonga na ndako",
    city_lock: "Etuka",
    city_lock_max: "30 km kaka",
    out_of_zone: "Esika oyo ezali libanda ya etuka",
  },
  wallet: {
    title: "Sakosi",
    balance: "Mbongo na yo",
    topup: "Batela",
    send_money: "Lisolo ya bofuti",
    send_subtitle: "Na motámboli to na moto nionso",
    recipient_phone: "Telefone ya oyo akozwa",
    amount: "Motango",
    note: "Liloba (soki olingi)",
    send: "Tinda",
    transactions: "Misala",
    no_transactions: "Misala te",
    transfer_success: "Otindi mbongo",
  },
  driver: {
    online: "NA KATI",
    offline: "LIBANDA",
    go_online: "Kota mpo na kozwa mibembo",
    no_requests: "Mobembo te sikoyo",
    incoming: "Mibembo mipya",
    active_ride: "Mobembo ya sikoyo",
    arrived_btn: "Nakomi",
    start_btn: "Banda",
    complete_btn: "Silisa",
    pending_banner: "Konti ezali kozela validation ya admin",
    earnings: "Mbongo na yo",
    earnings_note: "Sima ya kozwa 20% ya NEXORA",
    total_rides: "Mibembo",
    documents_title: "Mikanda na ngai",
    documents_subtitle: "Tia Permis, Carte grise, CIN pe Assurance",
    upload: "Tia",
    doc_driver_license: "Permis ya kotámbola",
    doc_vehicle_registration: "Carte grise",
    doc_id_card: "Pièce ya identité",
    doc_insurance: "Assurance",
    doc_pending: "Ezali kozela",
    doc_approved: "Endimi",
    doc_rejected: "Eboyami",
    doc_upload_success: "Mokanda etiami",
  },
  rating: {
    title: "Pesa point",
    submit: "Tinda évaluation",
    comment_placeholder: "Liloba (soki olingi)…",
    thanks: "Matondo mingi !",
  },
  sos: {
    trigger: "SOS",
    title: "Benga lisalisi",
    description: "Tokotinda esika na yo pe ba détails ya mobembo na équipe NEXORA.",
    note_placeholder: "Limbola likambo (soki olingi)…",
    confirm: "Benga lisalisi",
    sent: "Alerte etindi",
    call_112: "Benga 112",
  },
};

const sw = {
  common: {
    app_name: "NEXORA·CAB",
    loading: "Inapakia…",
    cancel: "Ghairi",
    confirm: "Thibitisha",
    save: "Hifadhi",
    back: "Rudi",
    close: "Funga",
    yes: "Ndiyo",
    no: "Hapana",
    language: "Lugha",
    language_fr: "Kifaransa",
    language_en: "Kiingereza",
    language_ln: "Kilingala",
    language_sw: "Kiswahili",
  },
  auth: {
    login: "Ingia",
    register: "Fungua akaunti",
    logout: "Toka",
    email_or_phone: "Barua pepe au simu",
    password: "Nenosiri",
    full_name: "Jina kamili",
    phone: "Nambari ya simu",
    email: "Barua pepe",
    city: "Mji",
    referral_code: "Nambari ya rufaa (hiari)",
    welcome: "Karibu NEXORA-CAB",
    role_customer: "Mteja",
    role_driver: "Dereva",
    no_account: "Bado huna akaunti ?",
    have_account: "Tayari una akaunti ?",
    create_account: "Fungua akaunti",
    sign_in: "Ingia",
  },
  home: {
    hello: "Habari",
    where_to: "Unaenda wapi ?",
    tap_map: "Gusa ramani · bei papo hapo",
    active_ride: "Safari inayoendelea",
    last_rides: "Safari za mwisho",
    see_all: "Angalia zote",
    none_yet: "Hakuna safari bado — agiza ya kwanza !",
    loyalty: "Uaminifu",
    points: "Pointi",
    next_tier_progress: "hadi",
    geo_in: "Uko",
    geo_account_in: "Akaunti yako imesajiliwa",
    geo_restricted: "Safari zinapatikana tu katika mji wako.",
  },
  ride: {
    step_pickup: "Uko wapi ?",
    step_dest: "Unaenda wapi ?",
    step_review: "Chagua gari",
    search_pickup: "Tafuta mahali pa kuanzia...",
    search_dest: "Tafuta unapoenda...",
    choose_vehicle: "Chagua gari",
    payment: "Malipo",
    subtotal: "Jumla ndogo",
    promo_code: "Nambari ya punguzo",
    promo_apply: "Tumia",
    total: "Jumla",
    order: "Agiza",
    searching_driver: "Inatafuta dereva",
    en_route: "Dereva njiani",
    arrived: "Dereva amefika",
    in_progress: "Safari inaendelea",
    completed: "Safari imekamilika",
    cancelled: "Safari imeghairiwa",
    pin_hint: "Nambari ya kumpa dereva",
    pay_now: "Lipa sasa",
    cancel: "Ghairi",
    tip: "Zawadi",
    rate: "Kadiria",
    back_home: "Rudi nyumbani",
    city_lock: "Eneo",
    city_lock_max: "kikomo 30 km",
    out_of_zone: "Eneo hili liko nje ya huduma",
  },
  wallet: {
    title: "Pochi",
    balance: "Salio",
    topup: "Ongeza pesa",
    send_money: "Historia ya malipo",
    send_subtitle: "Kwa dereva au mtu yeyote",
    recipient_phone: "Simu ya mpokeaji",
    amount: "Kiasi",
    note: "Ujumbe (hiari)",
    send: "Tuma",
    transactions: "Muamala",
    no_transactions: "Hakuna muamala",
    transfer_success: "Umetuma",
  },
  driver: {
    online: "MTANDAONI",
    offline: "NJE",
    go_online: "Ingia mtandaoni kupokea safari",
    no_requests: "Hakuna maombi sasa",
    incoming: "Maombi mapya",
    active_ride: "Safari inayoendelea",
    arrived_btn: "Nimefika",
    start_btn: "Anza",
    complete_btn: "Maliza",
    pending_banner: "Akaunti inasubiri idhini ya admin",
    earnings: "Mapato jumla",
    earnings_note: "Baada ya tume 20% ya NEXORA",
    total_rides: "Safari",
    documents_title: "Nyaraka zangu",
    documents_subtitle: "Pakia leseni, karatasi za gari, kitambulisho na bima",
    upload: "Pakia",
    doc_driver_license: "Leseni ya udereva",
    doc_vehicle_registration: "Karatasi za gari",
    doc_id_card: "Kitambulisho",
    doc_insurance: "Bima",
    doc_pending: "Inasubiri uthibitisho",
    doc_approved: "Imekubaliwa",
    doc_rejected: "Imekataliwa",
    doc_upload_success: "Hati imepakiwa",
  },
  rating: {
    title: "Kadiria",
    submit: "Tuma tathmini",
    comment_placeholder: "Maoni (hiari)…",
    thanks: "Asante !",
  },
  sos: {
    trigger: "SOS",
    title: "Piga simu ya dharura",
    description: "Tutatuma eneo lako la GPS na maelezo ya safari kwa timu ya NEXORA.",
    note_placeholder: "Eleza hali (hiari)…",
    confirm: "Piga simu ya dharura",
    sent: "Tahadhari imetumwa",
    call_112: "Piga 112",
  },
};

const en = {
  common: {
    app_name: "NEXORA-CAB",
    loading: "Loading...",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    back: "Back",
    close: "Close",
    yes: "Yes",
    no: "No",
    language: "Language",
    language_fr: "French",
    language_en: "English",
    language_ln: "Lingala",
    language_sw: "Swahili",
  },
  auth: {
    login: "Sign in",
    register: "Create account",
    logout: "Sign out",
    email_or_phone: "Email or phone",
    password: "Password",
    full_name: "Full name",
    phone: "Phone",
    email: "Email",
    city: "City",
    referral_code: "Referral code (optional)",
    welcome: "Welcome to NEXORA-CAB",
    role_customer: "Customer",
    role_driver: "Driver",
    no_account: "No account yet?",
    have_account: "Already registered?",
    create_account: "Create my account",
    sign_in: "Sign in",
  },
  home: {
    hello: "Hello",
    where_to: "Where are you going?",
    tap_map: "Tap the map - instant price",
    active_ride: "Active ride",
    last_rides: "Recent rides",
    see_all: "See all",
    none_yet: "No ride yet - book your first one!",
    loyalty: "Loyalty",
    points: "Points",
    next_tier_progress: "to",
    geo_in: "You are in",
    geo_account_in: "Your account is registered in",
    geo_restricted: "Rides are limited to your selected city.",
  },
  ride: {
    step_pickup: "Where are you?",
    step_dest: "Where are you going?",
    step_review: "Choose vehicle",
    search_pickup: "Search pickup address...",
    search_dest: "Search destination...",
    choose_vehicle: "Choose vehicle",
    payment: "Payment",
    subtotal: "Subtotal",
    promo_code: "Promo code",
    promo_apply: "Apply",
    total: "Total",
    order: "Book ride",
    searching_driver: "Searching for a driver",
    en_route: "Driver on the way",
    arrived: "Driver arrived",
    in_progress: "Ride in progress",
    completed: "Ride completed",
    cancelled: "Ride cancelled",
    pin_hint: "Code to give the driver",
    pay_now: "Pay now",
    cancel: "Cancel",
    tip: "Tip",
    rate: "Rate",
    back_home: "Back home",
    city_lock: "Zone",
    city_lock_max: "30 km max",
    out_of_zone: "This point is outside the service zone",
  },
  wallet: {
    title: "Payments",
    balance: "History",
    topup: "Unavailable",
    send_money: "Payment history",
    send_subtitle: "To the driver or anyone",
    recipient_phone: "Recipient phone",
    amount: "Amount",
    note: "Note (optional)",
    send: "View",
    transactions: "Payments",
    no_transactions: "No payment",
    transfer_success: "Transfer completed",
  },
  driver: {
    online: "ONLINE",
    offline: "OFFLINE",
    go_online: "Go online to receive rides",
    no_requests: "No requests for now",
    incoming: "Incoming requests",
    active_ride: "Active ride",
    arrived_btn: "I have arrived",
    start_btn: "Start",
    complete_btn: "Complete",
    pending_banner: "Account pending admin approval",
    earnings: "Total earnings",
    earnings_note: "After 20% NEXORA commission",
    total_rides: "Rides",
    documents_title: "My documents",
    documents_subtitle: "Upload license, registration, ID and insurance",
    upload: "Upload",
    doc_driver_license: "Driver license",
    doc_vehicle_registration: "Vehicle registration",
    doc_id_card: "Identity document",
    doc_insurance: "Insurance",
    doc_pending: "Pending review",
    doc_approved: "Approved",
    doc_rejected: "Rejected",
    doc_upload_success: "Document uploaded",
  },
  rating: {
    title: "Rate",
    submit: "Submit rating",
    comment_placeholder: "Comment (optional)...",
    thanks: "Thank you!",
  },
  sos: {
    trigger: "SOS",
    title: "Trigger SOS",
    description: "We will send your GPS location and ride details to the NEXORA team.",
    note_placeholder: "Describe the situation (optional)...",
    confirm: "Trigger alert",
    sent: "Alert sent",
    call_112: "Call 112",
  },
};

const extraTranslations = {
  fr: {
    nav: {
      home: "Accueil",
      book: "Reserver",
      services: "Services",
      payments: "Paiements",
      profile: "Profil",
      rides: "Courses",
      earnings: "Revenus",
    },
    services: {
      title: "Evenements et navettes",
      subtitle: "Reservez une place pour aeroport, ecole, stade, conference ou evenement. Le ticket reste dans l'app.",
      shuttle: "Navette",
      ticket: "Ticket",
      per_seat: "par place",
      capacity: "Capacite",
      departure: "Depart",
      payment: "Paiement",
      onboard: "A bord",
      seats: "Places",
      passenger_name: "Nom passager",
      pickup_placeholder: "Precision pickup: entree, arret, ecole...",
      reserve_ticket: "Reserver ticket",
      view_shuttles: "Voir navettes",
      taxi_now: "Course taxi",
      no_events: "Aucun evenement shuttle actif dans votre ville.",
      my_tickets: "Mes tickets",
      no_tickets: "Vos tickets shuttle apparaitront ici.",
      back_to_taxi: "Revenir aux courses taxi",
      ticket_reserved: "Ticket reserve",
      default_pickup: "Point Nexora",
    },
    admin: {
      menu: "Menu admin",
      close_menu: "Fermer menu",
      open_menu: "Ouvrir menu",
      dashboard: "Dashboard",
      overview: "Gestion",
      rides: "Courses",
      drivers: "Chauffeurs",
      users: "Utilisateurs",
      payments: "Paiements",
      finance: "Finance",
      disputes: "Litiges",
      ads: "Publicites",
      events: "Evenements",
      pricing: "Tarifs",
      sos: "SOS",
      documents: "Documents",
      audit: "Audit",
      settings: "Parametres",
      launch: "Lancement",
      profile: "Profil",
      group_control: "Pilotage",
      group_ops: "Operations",
      group_money: "Finances",
      group_trust: "Confiance",
      group_growth: "Croissance",
    },
    profile: {
      title: "Profil",
      options_title: "Options du compte",
      options_subtitle: "Profil, paiement, securite, support et profils avances.",
      settings: "Reglages",
      settings_subtitle: "Langue, theme et preferences de course",
      language: "Langue",
      language_subtitle: "Francais, English, Lingala, Swahili",
      city_service: "Ville de service",
      city_choose_hint: "Choisissez votre ville avant de commander",
      city_confirmed: "{{city}} - confirmee pour vos courses",
      choose_city: "Choisir ma ville",
      confirm_city: "Confirmer",
      verifying_gps: "Verification GPS...",
      push: "Notifications push",
      push_state: "Etat: {{state}}",
      push_missing: "Cle VAPID publique non configuree",
      activate: "Activer",
      notification_sound: "Son des notifications",
      sound_on: "Son in-app active comme une messagerie",
      sound_off: "Son in-app coupe",
      active: "Actif",
      muted: "Coupe",
      display_mode: "Mode d'affichage",
      light_active: "Mode clair actif",
      dark_active: "Mode sombre actif",
      dark: "Sombre",
      light: "Clair",
      preferences: "Preferences Uber-like",
    },
  },
  en: {
    nav: {
      home: "Home",
      book: "Book",
      services: "Services",
      payments: "Payments",
      profile: "Profile",
      rides: "Rides",
      earnings: "Earnings",
    },
    services: {
      title: "Events and shuttles",
      subtitle: "Book a seat for airport, school, stadium, conference or event trips. Your ticket stays in the app.",
      shuttle: "Shuttle",
      ticket: "Ticket",
      per_seat: "per seat",
      capacity: "Capacity",
      departure: "Departure",
      payment: "Payment",
      onboard: "On board",
      seats: "Seats",
      passenger_name: "Passenger name",
      pickup_placeholder: "Pickup details: entrance, stop, school...",
      reserve_ticket: "Reserve ticket",
      view_shuttles: "View shuttles",
      taxi_now: "Taxi ride",
      no_events: "No active shuttle event in your city.",
      my_tickets: "My tickets",
      no_tickets: "Your shuttle tickets will appear here.",
      back_to_taxi: "Back to taxi rides",
      ticket_reserved: "Ticket reserved",
      default_pickup: "Nexora point",
    },
    admin: {
      menu: "Admin menu",
      close_menu: "Close menu",
      open_menu: "Open menu",
      dashboard: "Dashboard",
      overview: "Control",
      rides: "Rides",
      drivers: "Drivers",
      users: "Users",
      payments: "Payments",
      finance: "Finance",
      disputes: "Disputes",
      ads: "Ads",
      events: "Events",
      pricing: "Pricing",
      sos: "SOS",
      documents: "Documents",
      audit: "Audit",
      settings: "Settings",
      launch: "Launch",
      profile: "Profile",
      group_control: "Control",
      group_ops: "Operations",
      group_money: "Money",
      group_trust: "Trust",
      group_growth: "Growth",
    },
    profile: {
      title: "Profile",
      options_title: "Account options",
      options_subtitle: "Profile, payments, safety, support and advanced profiles.",
      settings: "Settings",
      settings_subtitle: "Language, theme and ride preferences",
      language: "Language",
      language_subtitle: "French, English, Lingala, Swahili",
      city_service: "Service city",
      city_choose_hint: "Choose your city before booking",
      city_confirmed: "{{city}} - confirmed for your rides",
      choose_city: "Choose my city",
      confirm_city: "Confirm",
      verifying_gps: "Checking GPS...",
      push: "Push notifications",
      push_state: "Status: {{state}}",
      push_missing: "Public VAPID key is not configured",
      activate: "Enable",
      notification_sound: "Notification sound",
      sound_on: "In-app sound enabled like a messenger",
      sound_off: "In-app sound muted",
      active: "Active",
      muted: "Muted",
      display_mode: "Display mode",
      light_active: "Light mode active",
      dark_active: "Dark mode active",
      dark: "Dark",
      light: "Light",
      preferences: "Uber-like preferences",
    },
  },
  ln: {
    nav: {
      home: "Ndako",
      book: "Reserver",
      services: "Services",
      payments: "Kofuta",
      profile: "Profil",
      rides: "Mibembo",
      earnings: "Revenus",
    },
    services: {
      title: "Evenement mpe navette",
      subtitle: "Bomba esika mpo na aeroport, eteyelo, stade, conference to evenement. Ticket ekotikala na app.",
      shuttle: "Navette",
      ticket: "Ticket",
      per_seat: "na esika",
      capacity: "Capacite",
      departure: "Depart",
      payment: "Kofuta",
      onboard: "Na kati",
      seats: "Bisika",
      passenger_name: "Kombo ya passager",
      pickup_placeholder: "Polele pickup: porte, arret, eteyelo...",
      reserve_ticket: "Bomba ticket",
      view_shuttles: "Tala navette",
      taxi_now: "Taxi",
      no_events: "Evenement ya navette ezali te na mboka na yo.",
      my_tickets: "Ba ticket na ngai",
      no_tickets: "Ba ticket ya navette ekomonana awa.",
      back_to_taxi: "Zonga na taxi",
      ticket_reserved: "Ticket ebombami",
      default_pickup: "Point Nexora",
    },
    admin: {
      menu: "Menu admin",
      close_menu: "Kanga menu",
      open_menu: "Fungola menu",
      dashboard: "Dashboard",
      overview: "Gestion",
      rides: "Mibembo",
      drivers: "Ba chauffeur",
      users: "Ba utilisateurs",
      payments: "Bofuti",
      finance: "Finance",
      disputes: "Litiges",
      ads: "Pub",
      events: "Evenement",
      pricing: "Talo",
      sos: "SOS",
      documents: "Mikanda",
      audit: "Audit",
      settings: "Parametre",
      launch: "Lancement",
      profile: "Profil",
      group_control: "Pilotage",
      group_ops: "Operations",
      group_money: "Finances",
      group_trust: "Confiance",
      group_growth: "Croissance",
    },
    profile: {
      title: "Profil",
      options_title: "Ba options ya konti",
      options_subtitle: "Profil, bofuti, securite, support mpe ba profils avances.",
      settings: "Parametre",
      settings_subtitle: "Lokota, theme mpe preferences ya mobembo",
      language: "Lokota",
      language_subtitle: "Falense, English, Lingala, Swahili",
      city_service: "Mboka ya service",
      city_choose_hint: "Pona mboka na yo liboso ya ko commander",
      city_confirmed: "{{city}} - endimami mpo na mibembo na yo",
      choose_city: "Pona mboka na ngai",
      confirm_city: "Ndima",
      verifying_gps: "Verification GPS...",
      push: "Notifications push",
      push_state: "Etat: {{state}}",
      push_missing: "Cle VAPID publique ezali te",
      activate: "Activer",
      notification_sound: "Son ya notifications",
      sound_on: "Son ya app ezali active",
      sound_off: "Son ya app ekangami",
      active: "Actif",
      muted: "Kangami",
      display_mode: "Mode ya affichage",
      light_active: "Mode clair actif",
      dark_active: "Mode sombre actif",
      dark: "Sombre",
      light: "Clair",
      preferences: "Preferences Uber-like",
    },
  },
  sw: {
    nav: {
      home: "Nyumbani",
      book: "Agiza",
      services: "Huduma",
      payments: "Malipo",
      profile: "Wasifu",
      rides: "Safari",
      earnings: "Mapato",
    },
    services: {
      title: "Matukio na shuttle",
      subtitle: "Hifadhi nafasi kwa uwanja wa ndege, shule, uwanja, mkutano au tukio. Tiketi inabaki ndani ya app.",
      shuttle: "Shuttle",
      ticket: "Tiketi",
      per_seat: "kwa kiti",
      capacity: "Uwezo",
      departure: "Kuondoka",
      payment: "Malipo",
      onboard: "Ndani",
      seats: "Viti",
      passenger_name: "Jina la abiria",
      pickup_placeholder: "Maelezo pickup: mlango, kituo, shule...",
      reserve_ticket: "Hifadhi tiketi",
      view_shuttles: "Tazama shuttle",
      taxi_now: "Safari taxi",
      no_events: "Hakuna shuttle inayotumika katika mji wako.",
      my_tickets: "Tiketi zangu",
      no_tickets: "Tiketi zako za shuttle zitaonekana hapa.",
      back_to_taxi: "Rudi kwa safari za taxi",
      ticket_reserved: "Tiketi imehifadhiwa",
      default_pickup: "Pointi ya Nexora",
    },
    admin: {
      menu: "Menyu admin",
      close_menu: "Funga menyu",
      open_menu: "Fungua menyu",
      dashboard: "Dashboard",
      overview: "Usimamizi",
      rides: "Safari",
      drivers: "Madereva",
      users: "Watumiaji",
      payments: "Malipo",
      finance: "Fedha",
      disputes: "Migogoro",
      ads: "Matangazo",
      events: "Matukio",
      pricing: "Bei",
      sos: "SOS",
      documents: "Nyaraka",
      audit: "Audit",
      settings: "Mipangilio",
      launch: "Uzinduzi",
      profile: "Wasifu",
      group_control: "Udhibiti",
      group_ops: "Operesheni",
      group_money: "Fedha",
      group_trust: "Uaminifu",
      group_growth: "Ukuaji",
    },
    profile: {
      title: "Wasifu",
      options_title: "Chaguo za akaunti",
      options_subtitle: "Wasifu, malipo, usalama, msaada na profiles za ziada.",
      settings: "Mipangilio",
      settings_subtitle: "Lugha, mandhari na mapendeleo ya safari",
      language: "Lugha",
      language_subtitle: "Kifaransa, English, Lingala, Swahili",
      city_service: "Mji wa huduma",
      city_choose_hint: "Chagua mji wako kabla ya kuagiza",
      city_confirmed: "{{city}} - imethibitishwa kwa safari zako",
      choose_city: "Chagua mji wangu",
      confirm_city: "Thibitisha",
      verifying_gps: "Inakagua GPS...",
      push: "Arifa push",
      push_state: "Hali: {{state}}",
      push_missing: "Public VAPID key haijasanidiwa",
      activate: "Washa",
      notification_sound: "Sauti ya arifa",
      sound_on: "Sauti ya app imewashwa",
      sound_off: "Sauti ya app imezimwa",
      active: "Imeanza",
      muted: "Kimya",
      display_mode: "Hali ya mwonekano",
      light_active: "Hali nyeupe imewashwa",
      dark_active: "Hali nyeusi imewashwa",
      dark: "Nyeusi",
      light: "Nyeupe",
      preferences: "Mapendeleo Uber-like",
    },
  },
};

function mergeTranslations(base, extra) {
  Object.entries(extra).forEach(([key, value]) => {
    if (value && typeof value === "object" && !Array.isArray(value)) {
      base[key] = base[key] || {};
      mergeTranslations(base[key], value);
    } else {
      base[key] = value;
    }
  });
}

const resourcesBase = { fr, en, ln, sw };
Object.entries(extraTranslations).forEach(([lng, extra]) => mergeTranslations(resourcesBase[lng], extra));

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ln: { translation: ln },
      sw: { translation: sw },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en", "ln", "sw"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
